var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgReports = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-653 -406)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.581,6.725l-.789-.787L7.4,7.325l-.464-.463-.79.787L7.4,8.9Z",
    transform: "translate(653 406)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.743,
    height: 1.113,
    transform: "translate(663.69 412.665)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.581,10.125l-.789-.787L7.4,10.725l-.464-.463-.79.787L7.4,12.3Z",
    transform: "translate(653 406)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.743,
    height: 1.113,
    transform: "translate(663.69 416.065)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.581,13.525l-.789-.787L7.4,14.125l-.464-.463-.79.787L7.4,15.7Z",
    transform: "translate(653 406)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.743,
    height: 1.113,
    transform: "translate(663.69 419.466)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.42,3.625V0H0V14.375H3.579V18H18V3.625Zm-13.3,9.637V1.113H13.3V3.625H3.579v9.637Zm15.767,3.625H4.7V4.738H16.883Z",
    transform: "translate(653 406)"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgReports);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/reports.7be05cd987beb9ba90ca75f701e107f8.svg";